<div class="app-content">
  @if (settingsFG) {
    <div class="settings-fg-grid" [formGroup]="settingsFG">
      <div class="settings-fg-row">
        <div class="settings-fg-col text-select">
          <span>When on the last cell of a page and&nbsp;</span><b><i>tab</i></b><span>&nbsp;is pressed:&nbsp;</span>
          <button type="button" [disabled]="saving || disabledOpts.tabEnd" (click)="selectEnd($event, 'tab')">
            <span>
              {{ endSelection[settingsFG.get('tabEnd').value] }}
            </span>
            <app-icon-chevron-down></app-icon-chevron-down>
          </button>
        </div>
      </div>
      <div class="settings-fg-row">
        <div class="settings-fg-col text-select">
          <span>When on the last cell of a column and&nbsp;</span><b><i>enter</i></b><span>&nbsp;is pressed:&nbsp;</span>
          <button type="button" [disabled]="saving || disabledOpts.enterEnd" (click)="selectEnd($event, 'enter')">
            <span>
              {{ endSelection[settingsFG.get('enterEnd').value] }}
            </span>
            <app-icon-chevron-down></app-icon-chevron-down>
          </button>
        </div>
      </div>
      <div class="settings-fg-row">
        <div class="settings-fg-col sexy-modal-main-buttons">
          <button type="button" mat-button [disabled]="saving" (click)="onClose()">Cancel</button>
          <button type="button" mat-button [disabled]="saving" (click)="onSave()">Save Settings</button>
        </div>
      </div>
    </div>
  }
</div>
